import "./Memberships.module.css";
import MainNavigation from "@/reusable_sections/Header";
import ChooseYourPackage from "./sections/ChooseYourPackage";
import CommonQuestions from "./sections/CommonQuestions";
import Footer from "@/reusable_sections/Footer";
import MembersHero from "./sections/MembersHero";
import MembershipNarrative from "./sections/MembershipNarrative";
import MemberBenefits from "./sections/MemberBenefits";
import FinalCallToAction from "./sections/FinalCallToAction";
import MembersOnlyPerks from "./sections/MembersOnlyPerks";
import WhyMembershipWorks from "./sections/WhyMembershipWorks";
import ServiceProcessGrid from "./sections/ServiceProcessGrid";
export default function MembershipsPage() {
  return <div>
      <MainNavigation />
      <MembersHero />
      <MembershipNarrative />
      <ChooseYourPackage />
      <MemberBenefits />
      <MembersOnlyPerks />
      <WhyMembershipWorks />
      <CommonQuestions />
      <FinalCallToAction />
      <ServiceProcessGrid />
      <Footer />
    </div>;
}